<template>
	<div class="mirror-list-container init">
		<div class="cps-page-top">
			<div class="jc-page-header">
				<el-page-header :title="$t('mirror.text.title')" />
				<div class="jc-box-action">
					<a :href="Config.MIRROR_HELP_URL" target="_blank">{{ $t('mirror.text.doc') }}</a>
				</div>
			</div>
			<div class="jc-page-content">
				<el-tabs v-model="mirrorType">
				    <el-tab-pane v-for="(mirror, index) in MirrorTypesConstant" :label="mirror.text" :key="index" :name="mirror.value"></el-tab-pane>
				</el-tabs>
				<div class="jc-container-table">
					<div class="jc-container-table-actionBar flex-display">
						<!--刷新、地域、申请-->
						<el-form class="jc-table-actionBar-item" :inline="true">
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
									@click="updateList('refresh')">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-radio-group v-model="region" @change="regionChange">
									<el-radio-button v-for="(area, index) in regions"
										:key="index"
										:label="area.region">
										{{ area.regionName }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<!--导入镜像-->
<!-- 							<el-form-item>
								<el-button type="primary" @click="importMirror">
									{{ $t('mirror.text.importMirror') }}
								</el-button>
							</el-form-item> -->
						</el-form>
						<!--搜索、筛选标签、自定义、下载-->
						<el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
							<el-form-item>
								<el-input v-entire-placeholder
									@keyup.enter.native="updateList('refresh')"
									:placeholder="currentPlaceholder"
									v-model="currentSearchValue" style="width:412px">
									<el-select
										slot="prepend" id="my-select" v-model="currentSearch"
										@change="changeSearch"
										:placeholder="$t('listPage.placeholder.choose')" style="width:105px">
										<el-option class="my-select-input" v-for="item in searchSelect"
											:key="item.searchValue"
											:label="item.searchLabel" :value="item.searchValue">
										</el-option>
									</el-select>
									<el-button 
										slot="append" icon="jc-icon-search" class="search-icon"
										@click="updateList('refresh')">
									</el-button>
								</el-input>
							</el-form-item>
							<el-form-item>
								<el-button icon="el-icon-setting" class="jc-button-icon cps-custom-icon"
									@click="customVisible = true"
									:title="$t('listPage.text.customList')">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-button class="jc-button-icon cps-custom-icon" icon="jc-icon-download"
									@click="exportList"
									:title="$t('listPage.text.exportList')">
								</el-button>
							</el-form-item>
						</el-form>
						
					</div>
					<!--镜像列表-->
					<el-table 
						@filter-change="filterChange" 
						:data="tableData" style="width:100%"
						class="jc-list-table jc-table-header-cell" 
						v-loading="refreshLoading"
						ref="listTable"
						:empty-text="$t('speechCraft.listEmptyText')">
						<!--ID/镜像名称-->
						<el-table-column :label="$t('mirror.text.mirrorIdAndName')" 
							min-width="230" 
							key="id"
							v-if="customInfo !== null && customInfo.imageId && customInfo.imageId.selected">
							<template slot-scope="scope">
								<!--ID-->
								<div class="inline-ip" 
									@mouseover="ipHover" 
									@mouseout="ipDisplayNone">
									<el-tooltip class="item" effect="dark" 
										:content="scope.row.imageId"
										placement="bottom">
										<span>{{scope.row.imageId | maybeEmpty}}</span>
									</el-tooltip>
									<div class="right" v-show="copyHover">
										<copy-value :copyVal="`${scope.row.imageId}`"></copy-value>	
									</div>	
								</div>
								<!--镜像名称-->
								<div>
									<el-tooltip class="item" effect="dark" 
										:content="scope.row.imageName"
										placement="bottom">
										<a href="javascript:void(0)"
											@click="jumpToDetail(scope.row.imageId, scope.row.imageKind)">{{scope.row.imageName
											| maybeEmpty}}</a>
									</el-tooltip>
								</div>
							</template>
						</el-table-column>
						<!--状态-->
						<el-table-column :label="$t('eip.text.status')" min-width="90" key="status"
							prop="status"
							:filters="MirrorStatusConstant" 
							:filter-multiple="false"
							column-key="status" filter-placement="bottom-start"
							v-if="customInfo !== null && customInfo.status && customInfo.status.selected">
							<template slot-scope="scope">
								<span
									:class="getClassByStatus(scope.row.status)">{{scope.row.statusName |
									maybeEmpty}}</span>
							</template>
						</el-table-column>
						<!--私有镜像类型-->
						<el-table-column prop="imageKind" min-width="100" key="private"
							:label="$t('mirror.text.mirrorType')"
							v-if="customInfo !== null && customInfo.imageKind && customInfo.imageKind.selected && mirrorType === 'private'"
							>
							<template slot-scope="scope">
								<span>{{scope.row.imageKindName |
									maybeEmpty}}</span>
							</template>
						</el-table-column>
						<!--公共/定制镜像类型-->
						<el-table-column 
							:filters="PublicMirrorTypesConstant"
							:filter-multiple="false"
							column-key="imageKind" 
							filter-placement="bottom-start"
							prop="imageKind" min-width="100" key="common"
							:label="$t('mirror.text.mirrorType')"
							v-if="customInfo !== null && customInfo.imageKind && customInfo.imageKind.selected && mirrorType === 'common'"
							>
							<template slot-scope="scope">
								<span>{{scope.row.imageKindName |
									maybeEmpty}}</span>
							</template>
						</el-table-column>
						<!--体系架构-->
						<el-table-column 
							:filters="filters.architecture" 
							:filter-multiple="false"
							column-key="architecture" filter-placement="bottom-start"
							prop="architecture" 
							min-width="70" 
							:label="$t('mirror.text.architecture')"
							v-if="customInfo !== null && customInfo.architecture && customInfo.architecture.selected">
							<template slot-scope="scope">
								<span>{{scope.row.architecture | maybeEmpty}}</span>
							</template>
						</el-table-column>
						<!--操作系统平台-->
						<el-table-column 
							:filters="filters.osType" 
							:filter-multiple="false"
							column-key="osType" filter-placement="bottom-start"
							prop="ostype" 
							min-width="110"
							:label="$t('mirror.text.osType')"
							v-if="customInfo !== null && customInfo.osType && customInfo.osType.selected">
							<template slot-scope="scope">
								<span>{{scope.row.osType | maybeEmpty}}</span>
							</template>
						</el-table-column>
						<!--操作系统版本-->
						<el-table-column 
							:filters="filters.systemVersion" 
							:filter-multiple="false"
							filter-placement="bottom-start"
							column-key="systemVersion"
							prop="systemVersion" 
							:label="$t('mirror.text.systemVersion')" min-width="110"
							v-if="customInfo !== null && customInfo.systemVersion && customInfo.systemVersion.selected" :show-overflow-tooltip="true">
							<template slot-scope="scope">
								<span>{{scope.row.systemVersion | maybeEmpty}}</span>
							</template>
						</el-table-column>
						<!--创建时间-->
						<el-table-column min-width="105" key="bandwidth" prop="bandwidth"
							:label="$t('mirror.text.createTime')"
							v-if="customInfo !== null && customInfo.createTime && customInfo.createTime.selected">
							<template slot-scope="scope">
								<span>{{scope.row.createTime | maybeEmpty}}</span>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column 
							v-if="mirrorType === 'private'"
							key="operation" min-width="135"
							:label="$t('listPage.tableLabel.operation')">
							<template slot-scope="scope">
								<!--创建实例-->
								<el-button 
	                                type="text"
	                                @click="jumpToVpcInstanceCreate">
	                                {{ $t('mirror.text.createInstance') }}
                            	</el-button>
                            	<!--删除镜像-->
	                            <el-tooltip 
	                            	placement="bottom"
	                                :content="$t('mirror.tips.createdInstanceDeleteNotAllowed')"
	                                :visible-arrow="false"
	                                :disabled="scope.row.instanceCount < 1">
	                                <label>
	                                    <el-button type="text"
	                                        @click="openDeleteMirrorDialog(scope.row)"
	                                        :disabled="scope.row.instanceCount >= 1 || scope.row.status === 'making'">
	                                        {{ $t('privateNetwork.delete') }}
	                                    </el-button>
                                	</label>
	                            </el-tooltip>
                        	</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<custom :visible.sync="customVisible" 
				v-if="customVisible" :optionArr="optionArr"
				:type="type"></custom>
			<!--删除镜像-->
			<delete-mirror 
				:visible.sync="deleteMirrorDialogVisible"
				@refresh="updateList('refresh')"
				:rowInfo="currentRow"
				:pageSource="'list'"
				:region="region">
			</delete-mirror>
		</div>
		<div ref="footer" class="cps-page-footer jc-container-table-actionBar" v-if="total > 0">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	MirrorTypesConstant,
	NetworkTypeConstant,
	EipOperationConstant,
	InstanceTypeConstant,
	OverdueConstantArray,
	ArrearConstantArray,
	ServiceCodeConstant,
	ChargeModeConstant,
	MirrorStatusConstant,
	PublicMirrorTypesConstant
} from '@/common/Constants';
import {queryUserImageApi, queryCommonImageApi, describeImageSelectsApi, exportImagesApi} from '@/api/mirror/list/actions'
import custom from '@/components/common/custom/Custom';
import DeleteMirror from '@/components/common/DeleteMirror';
import copyValue from '@/components/privateNetwork/CopyValue';
import regionName from '@/mixins/regionName';
import isDestroyingMixins from '@/mixins/isDestroying';
const initPage = 1;

export default {
	name: 'MirrorList',
	mixins: [regionName, isDestroyingMixins],
	components: {
		custom,
		DeleteMirror,
		copyValue
	},
	data() {
		// 模糊搜索条件设置
		const searchSelect = [
			{
				searchValue: 'mirrorId',
				searchLabel: this.$t('mirror.text.mirrorId')
			},
			{
				searchValue: 'mirrorName',
				searchLabel: this.$t('mirror.text.mirrorName')
			}
		];
		return {
			networkTypeMap: {
				basic: this.$t('listPage.text.baseNet')
			},
			mirrorType: 'private',
			currentPage: initPage,
			initPage,
			form: {},
			regions: [],
			region: null,
			tableData: [],
			refreshLoading: false,
			minBandwidth: 0,
			idSearch: '',
			nameSearch: '',
			search: 'instanceId',
			currentSearch: 'mirrorId',
			copyHover:false,
			// 当前搜索input框值
			currentSearchValue: '',
			// 搜索条件下拉选
			searchSelect,
			// 当前搜索条件对应placeholder
			currentPlaceholder: this.$t('mirror.tips.search.mirrorId'),
			pageSize: 20,
			pageSizes: [20, 50, 100], // 可选每页展示多少条
			total: 0,
			// 自定义列表是否显示
			customVisible: false,
			// 自定义列表表头
			optionArr: [
				{
					// ID/镜像名称
					label: this.$t('mirror.text.mirrorIdAndName'),
					value: 'imageId'
				},
				{
					// 状态
					label: this.$t('list.status'),
					value: 'status'
				},
				{
					// 镜像类型
					label: this.$t('mirror.text.mirrorType'),
					value: 'imageKind'
				},
				{
					// 体系架构
					label: this.$t('mirror.text.architecture'),
					value: 'architecture'
				},

				{
					// 操作系统平台
					label: this.$t('mirror.text.osType'),
					value: 'osType'
				},
				{
					// 操作系统版本
					label: this.$t('mirror.text.systemVersion'),
					value: 'systemVersion'
				},
				{
					// 创建时间
					label: this.$t('mirror.text.createTime'),
					value: 'createTime'
				},
			],
			// 自定义列表类型
			type: 'imageList',
			// 筛选条件
			statusFilter: ['architecture','osType','systemVersion'],
			// 选择的状态筛选条件的值
			status: '',
			imageKind: '',
			architecture: '',
			osType: '',
			systemVersion: '',
			filters: {
				architecture: [],
				systemVersion: [],
				osType: []
			},
			// 当前行所有数据
			currentRow: {},
			// 删除镜像弹框
			deleteMirrorDialogVisible: false,
			statusTimeOut: null,
		};
	},
	computed: {
		MirrorTypesConstant: () => MirrorTypesConstant,
		ServiceCodeConstant: () => ServiceCodeConstant,
		customInfo() {
			return this.$store.state.customInfo[this.type];
		},
		InstanceTypeConstant: () => InstanceTypeConstant,
		EipOperationConstant: () => EipOperationConstant,
		OverdueConstantArray: () => OverdueConstantArray,
		ArrearConstantArray: () => ArrearConstantArray,
		ChargeModeConstant: () => ChargeModeConstant,
		MirrorStatusConstant: () => MirrorStatusConstant,
		PublicMirrorTypesConstant: () => PublicMirrorTypesConstant
	},
	watch: {
		region(newValue) {
			if(newValue) {
				this.regionChange()
			}
		},

		mirrorType(newValue) {
			clearTimeout(this.statusTimeOut);
			if (newValue === "private") {
				this.getUserImageList();
			} else if (newValue === "common") {
				this.getCommonImageList();
			}
		}
	},
	async created() {
		if (this.$store.state.customInfo[this.type] === null) {
			this.getCustomInfo();
		}
		await this.getRegion();
		this.getImageSelects();
	},

	destroyed() {
		clearTimeout(this.statusTimeOut);
	},
	
	methods: {

		// 获取私有镜像列表
		getUserImageList() {
      if (this.isDestroying) {
          return
      }
			// 基础参数
			const param = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
				imageKind: this.mirrorType
			};
			// 搜索部分添加参数
			if (this.currentSearchValue) {
				switch (this.currentSearch) {
					case 'mirrorId': {
						param.imageId = this.currentSearchValue;
						break;
					}
					case 'mirrorName': {
						param.imageName = this.currentSearchValue;
						break;
					}
				}
			}
			// 状态筛选参数
			if (this.status) {
				param.status = this.status;
			}
			// 体系架构筛选参数
			if (this.architecture) {
				param.architecture = this.architecture;
			}
			// 操作系统平台筛选参数
			if (this.osType) {
				param.osType = this.osType;
			}
			// 操作系统版本筛选参数
			if (this.systemVersion) {
				param.systemVersion = this.systemVersion;
			}
			queryUserImageApi(param).then(res => {
				const list = res.data.userImageInfoList;
				this.tableData = list;
				this.total = res.data.totalCount;
				const pollingTag = list.some(item => item.status === 'making');
				if (pollingTag) {
					clearTimeout(this.statusTimeOut);
					this.statusTimeOut = setTimeout(() => {
						this.getUserImageList();
					}, 5000);
				}
			}).catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.tableData = [];
                    this.total = 0;
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.refreshLoading = false;
            });
		},
		// 获取私有镜像列表
		getCommonImageList() {
      if (this.isDestroying) {
          return
      }
			// 基础参数
			const param = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
			// 搜索部分添加参数
			if (this.currentSearchValue) {
				switch (this.currentSearch) {
					case 'mirrorId': {
						param.imageId = this.currentSearchValue;
						break;
					}
					case 'mirrorName': {
						param.imageName = this.currentSearchValue;
						break;
					}
				}
			}
			// 镜像类型筛选参数
			if (this.imageKind) {
				param.imageKind = this.imageKind;
			}
			// 状态筛选参数
			if (this.status) {
				param.status = this.status;
			}
			// 体系架构筛选参数
			if (this.architecture) {
				param.architecture = this.architecture;
			}
			// 操作系统平台筛选参数
			if (this.osType) {
				param.osType = this.osType;
			}
			// 操作系统版本筛选参数
			if (this.systemVersion) {
				param.systemVersion = this.systemVersion;
			}
			queryCommonImageApi(param).then(res => {
				const list = res.data.commonImageInfoList;
				this.tableData = list;
				this.total = res.data.totalCount;
				const pollingTag = list.some(item => item.status === 'making');
				if (pollingTag) {
					clearTimeout(this.statusTimeOut);
					this.statusTimeOut = setTimeout(() => {
						this.getCommonImageList();
					}, 5000);
				}
			}).finally(() => {
                this.refreshLoading = false;
            });
		},
		getRegion() {
			const params = {
				networkType: NetworkTypeConstant.VPC
			};
			return Ajax.get('api/cps/getRegions', params).then((res) => {
				res.data.regions.map((region, index) => {
					if (index === 0) {
						if (this.$route.query && this.$route.query.region) {
							this.region = this.$route.query.region;
						} else {
							this.region = region.region;
						}
					}
					const tempFormat = {};
					tempFormat.region = region.region;
					tempFormat.regionName = region.regionName;
					this.regions.push(tempFormat);
				});

			}) 
			.catch()
	        .finally(() => {
	        	this.loading = false
	        });
		},
		updateList(type) {
			if (type === 'refresh') {
				this.refreshLoading = true;
				this.currentPage = 1;
			}
			let mirrorType = this.mirrorType;
			if (mirrorType === "private") {
				this.getUserImageList();
			} else if (mirrorType === "common") {
				this.getCommonImageList();
			}
		},

		// 选择地区
		regionChange() {
			this.$refs.listTable.clearFilter();
			this.currentSearchValue = '';
			this.updateList('refresh');
		},
		// 跳转到详情页
		jumpToDetail(imageId,imageKind) {
			let regionName = this.getRegionName(this.region);
			this.$router.push({
				path: '/image/detail',
				query: {
					region: this.region,
					imageId,
					imageKind,
					regionName
				}
			});
		},
		// 导入镜像
		importMirror() {
			console.log('importMirror')
		},
		// 修改搜索条件
		changeSearch() {
			const searchPlaceholder = this.$t('mirror.tips.search');
			const currentSearchVar = this.currentSearch;
			this.currentPlaceholder = searchPlaceholder[currentSearchVar];
			// 清空当前搜索条件
			this.currentSearchValue = '';
		},
		// 导出列表接口
		exportList() {
			let imageKind = this.mirrorType === 'private' ? 'private' : 'public,customize';
			// 镜像筛选参数
			if (this.imageKind) {
				imageKind = this.imageKind;
			}
			let temp = `&imageKind=${imageKind}`;
			// 搜索部分添加参数
			if (this.currentSearchValue) {
				switch (this.currentSearch) {
					case 'mirrorId': {
						temp += `&imageId=${this.currentSearchValue}`;
						break;
					}
					case 'mirrorName': {
						temp += `&imageName=${this.currentSearchValue}`;
						break;
					}
				}
			}
			// 状态筛选参数
			if (this.status) {
				temp += `&status=${this.status}`;
			}
			// 体系架构筛选参数
			if (this.architecture) {
				temp += `&architecture=${this.architecture}`;
			}
			// 操作系统平台筛选参数
			if (this.osType) {
				temp += `&osType=${this.osType}`;
			}
			// 操作系统版本筛选参数
			if (this.systemVersion) {
				temp += `&systemVersion=${this.systemVersion}`;
			}
			const url = `/cps_api/api/export/exportImages?pageNumber=${this.currentPage}&pageSize=${this.pageSize}&region=${this.region}${temp}`;
			window.open(url, '_self');

			// const param = {
			// 	region: this.region,
			// 	pageNumber: this.currentPage,
			// 	pageSize: this.pageSize,
			// 	imageKind: this.mirrorType
			// };
			// // 搜索部分添加参数
			// if (this.currentSearchValue) {
			// 	switch (this.currentSearch) {
			// 		case 'mirrorId': {
			// 			param.imageId = this.currentSearchValue;
			// 			break;
			// 		}
			// 		case 'mirrorName': {
			// 			param.imageName = this.currentSearchValue;
			// 			break;
			// 		}
			// 	}
			// }
			// // 状态筛选参数
			// if (this.status) {
			// 	param.status = this.status;
			// }
			// // 体系架构筛选参数
			// if (this.architecture) {
			// 	param.architecture = this.architecture;
			// }
			// // 操作系统平台筛选参数
			// if (this.osType) {
			// 	param.osType = this.osType;
			// }
			// // 操作系统版本筛选参数
			// if (this.systemVersion) {
			// 	param.systemVersion = this.systemVersion;
			// }

			// exportImagesApi(param).then(res => {
			// 	console.log(res);
			// })
		},
		// 切换每一页多少条
		handleSizeChange(val) {
			this.pageSize = val;
			this.updateList('refresh');
		},
		// 切换当前页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.updateList();
		},
		getCustomInfo() {
			const param = {
				pageKey: this.type
			};
			Ajax.get('/api/usercenter/getCustomInfo', param).then(res => {
				if (res.data.customInfo) {
					this.$store.commit('GET_CUSTOMINFO', { value: res.data.customInfo, type: this.type });
				}
			})
		},
		filterChange(filter) {
			this.currentPage = 1;
			for (const key in filter) {
				switch (key) {
					case "status": {
						this.status = filter[key][0];
						break;
					}
					case "imageKind": {
						this.imageKind = filter[key][0];
						break;
					}
					case "architecture": {
						this.architecture = filter[key][0];
						break;
					}
					case "osType": {
						this.osType = filter[key][0];
						break;
					}
					case "systemVersion": {
						this.systemVersion = filter[key][0];
						break;
					}
				}
			}
			let mirrorType = this.mirrorType;
			if (mirrorType === "private") {
				this.getUserImageList();
			} else if (mirrorType === "common") {
				this.getCommonImageList();
			}
		},

		openDeleteMirrorDialog(row) {
		  	this.currentRow = row;
		  	this.deleteMirrorDialogVisible = true;
		},

		jumpToVpcInstanceCreate() {
			this.$router.push({
	        	path: '/instance/vpc/create',
	        	query: { region: this.region }
		    });
		},

		getImageSelects() {
			let types = this.statusFilter.join();
			let params = {
				region: this.region,
				type: types
			};
			describeImageSelectsApi(params).then(res => {
				Object.keys(res.data).map((key) => {
					this.filters[key] = res.data[key].map(item => {
						return {
							text: item.key,
							value: item.value
						}
					});
				});
			});
		},

		ipHover() {
			this.copyHover=true
		},

		ipDisplayNone() {
			this.copyHover=false
		},

		getClassByStatus(status) {
	      	switch (status) {
				case 'available':
					return ['status-success'];
				case 'error':
					return ['status-error'];
				case 'making':
					return ['status-middle'];
				default:
					return ['status-middle'];
	      	}

	    },
	}
};
</script>


<style lang="scss">
	@import '~@/assets/scss/listComon.scss';
	@import '~@/assets/scss/paginationCommon.scss';
	@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/mirror/list/List.vue